import { Dispatch } from 'redux';
import { StatisticsActionTypes, PeriodType } from '../../constants/Statistics';
import { StatisticsApiClient } from './api';

/**
 * 全施設の統計データを取得
 */
export const fetchAllInstitutionsStatistics = (periodType: PeriodType, date: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: StatisticsActionTypes.FETCH_START });

    try {
      const client = await StatisticsApiClient.ClientFactory();
      const data = await client.getAllInstitutionsStatistics(periodType, date);

      dispatch({
        type: StatisticsActionTypes.FETCH_SUCCESS,
        payload: data,
      });
    } catch (error: any) {
      const errorMessage = error.response?.data?.message || error.message || '統計データの取得に失敗しました';
      dispatch({
        type: StatisticsActionTypes.FETCH_ERROR,
        error: errorMessage,
      });
    }
  };
};

/**
 * 期間タイプを変更
 */
export const setPeriodType = (periodType: PeriodType) => ({
  type: StatisticsActionTypes.SET_PERIOD_TYPE,
  payload: periodType,
});

/**
 * 日付を変更
 */
export const setDate = (date: string) => ({
  type: StatisticsActionTypes.SET_DATE,
  payload: date,
});

/**
 * 状態をリセット
 */
export const resetStatistics = () => ({
  type: StatisticsActionTypes.RESET,
});

/**
 * 前の期間に移動
 */
export const goToPreviousPeriod = (periodType: PeriodType, currentDate: string) => {
  return (dispatch: Dispatch) => {
    let newDate: string;

    if (periodType === 'weekly') {
      // 7日前
      const date = new Date(currentDate);
      date.setDate(date.getDate() - 7);
      newDate = formatDate(date);
    } else {
      // 1ヶ月前
      const [year, month] = currentDate.split('-').map(Number);
      const newMonth = month - 1;
      if (newMonth < 1) {
        newDate = `${year - 1}-12`;
      } else {
        newDate = `${year}-${String(newMonth).padStart(2, '0')}`;
      }
    }

    dispatch(setDate(newDate));
    return newDate;
  };
};

/**
 * 次の期間に移動
 */
export const goToNextPeriod = (periodType: PeriodType, currentDate: string) => {
  return (dispatch: Dispatch) => {
    let newDate: string;

    if (periodType === 'weekly') {
      // 7日後
      const date = new Date(currentDate);
      date.setDate(date.getDate() + 7);
      newDate = formatDate(date);
    } else {
      // 1ヶ月後
      const [year, month] = currentDate.split('-').map(Number);
      const newMonth = month + 1;
      if (newMonth > 12) {
        newDate = `${year + 1}-01`;
      } else {
        newDate = `${year}-${String(newMonth).padStart(2, '0')}`;
      }
    }

    dispatch(setDate(newDate));
    return newDate;
  };
};

/**
 * 期間タイプを切り替えて日付をリセット
 */
export const changePeriodType = (newPeriodType: PeriodType) => {
  return (dispatch: Dispatch) => {
    const today = new Date();
    let newDate: string;

    if (newPeriodType === 'weekly') {
      // 今週の月曜日
      const day = today.getDay();
      const diff = today.getDate() - day + (day === 0 ? -6 : 1);
      const monday = new Date(today.setDate(diff));
      newDate = formatDate(monday);
    } else {
      // 今月
      newDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}`;
    }

    dispatch(setPeriodType(newPeriodType));
    dispatch(setDate(newDate));
    return newDate;
  };
};

function formatDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
